var React = require('react');

function Stackoverflow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 27V19H24V30H0V19H3V27H21Z","fill":"#BCBBBB","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.1 0.199997L15 1.8L22.9 12.4L25 10.8L17.1 0.199997ZM20.8 14.9L10.6 6.4L12.3 4.4L22.5 12.9L20.8 14.9ZM7.2 12.3L19.2 17.9L20.3 15.5L8.3 9.9L7.2 12.3ZM5.4021 19.1011L18.9631 21.061L19.127 18.6804L5.87134 16.134L5.4021 19.1011ZM19 25H5V22H19V25Z","key":1})]);
}

Stackoverflow.defaultProps = {"viewBox":"0 0 25 30","fill":"none"};

module.exports = Stackoverflow;

Stackoverflow.default = Stackoverflow;
